import styled from 'styled-components'
const ShippingCostWrapper = styled.div`
.title {
  font-weight: bold;
}
.margin-text {
  margin-right: 10px;
}
`
export default ShippingCostWrapper